<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">메뉴관리</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">메뉴 등록</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                메뉴 등록 테이블
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">메뉴ID<span class="redDot">*</span></th>
                  <td>
                    <input type="text" title="메뉴ID 입력" placeholder="메뉴ID 자동생성" disabled class="md" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">메뉴순서<span class="redDot">*</span></th>
                  <td>
                    <input type="text" title="메뉴순서 입력" class="md" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">메뉴명<span class="redDot">*</span></th>
                  <td>
                    <input type="text" title="메뉴명 입력" class="md" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">상위메뉴ID<span class="redDot">*</span></th>
                  <td>
                    <div class="flex">
                      <input type="text" title="상위메뉴ID 입력" class="md" />
                      <button type="button" class="btn gray" @click="menuRegist">메뉴선택 검색</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">파일명<span class="redDot">*</span></th>
                  <td>
                    <div class="flex">
                      <input type="text" title="파일명 입력" class="md" />
                      <button type="button" class="btn gray">프로그램 파일명 검색</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">관련 이미지명<span class="redDot">*</span></th>
                  <td>
                    <input type="text" title="관련 이미지명 입력" class="md" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">관련 이미지 경로<span class="redDot">*</span></th>
                  <td>
                    <input type="text" title="관련 이미지 경로 입력" class="md" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">메뉴설명</th>
                  <td>
                    <textarea name="" id="" style="resize: none"></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class="btnArea">
          <button class="btn border" @click="$router.push('menulist')">목록</button>
          <button class="btn gray">취소</button>
          <button class="btn blue">저장</button>
        </article>
      </div>
    </section>

    <!-- 메뉴 등록 -->
    <popup v-if="showModal" class="w660">
      <template #info> 메뉴 등록 </template>
      <template #content>
        <article>
          <div class="treeMenuArea">
            <div class="col">
              <span>1 Depth메뉴</span>

              <div class="treeMenu">
                <v-treeview
                  v-model="tree"
                  :open="initiallyOpen"
                  :items="items"
                  activatable
                  item-key="name"
                  dense
                  open-on-click
                >
                  <template v-slot:prepend="{ item, open }">
                    <v-icon v-if="!item.file">
                      {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                    </v-icon>
                    <v-icon v-else>
                      {{ files[item.file] }}
                    </v-icon>
                  </template>
                </v-treeview>
              </div>
            </div>
            <div class="col">
              <span>2 Depth메뉴</span>

              <div class="treeMenu">
                <v-treeview
                  v-model="tree"
                  :open="initiallyOpen"
                  :items="items"
                  activatable
                  item-key="name"
                  dense
                  open-on-click
                >
                  <template v-slot:prepend="{ item, open }">
                    <v-icon v-if="!item.file">
                      {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                    </v-icon>
                    <v-icon v-else>
                      {{ files[item.file] }}
                    </v-icon>
                  </template>
                </v-treeview>
              </div>
            </div>
            <div class="col">
              <span>3 Depth메뉴</span>

              <div class="treeMenu">
                <v-treeview
                  v-model="tree"
                  :open="initiallyOpen"
                  :items="items"
                  activatable
                  item-key="name"
                  dense
                  open-on-click
                >
                  <template v-slot:prepend="{ item, open }">
                    <v-icon v-if="!item.file">
                      {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                    </v-icon>
                    <v-icon v-else>
                      {{ files[item.file] }}
                    </v-icon>
                  </template>
                </v-treeview>
              </div>
            </div>
          </div>
        </article>
        <article class="btnArea">
          <button class="btn gray" @click="CloseBtn">취소</button>
          <button class="btn blue">선택</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CloseBtn"><span class="hidden">닫기</span></button>
      </template>
    </popup>
  </main>
</template>

<script>
import axios from 'axios';
import Popup from '../../../components/PopupType1.vue';

export default {
  data() {
    return {
      showModal: false,
      initiallyOpen: ['public'],
      files: {
        html: 'mdi-language-html5',
        js: 'mdi-nodejs',
        json: 'mdi-code-json',
        md: 'mdi-language-markdown',
        pdf: 'mdi-file-pdf',
        png: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
      },
      tree: [],
      items: [
        {
          name: 'Root Item 1',
          children: [
            {
              name: 'Sub Item 1',
              children: [
                {
                  name: 'Sub item 1.1',
                  file: 'txt',
                },
                {
                  name: 'Sub item 1.2',
                  file: 'txt',
                },
              ],
            },
            {
              name: 'Sub Item 2',
              children: [
                {
                  name: 'Sub item 2.1',
                  file: 'txt',
                },
                {
                  name: 'Sub item 2.2',
                  file: 'txt',
                },
              ],
            },
            {
              name: 'Sub Item 3',
              children: [
                {
                  name: 'Sub item 3.1',
                  file: 'txt',
                },
                {
                  name: 'Sub item 3.2',
                  file: 'txt',
                },
              ],
            },
          ],
        },
      ],
    };
  },

  components: {
    Popup,
  },

  mounted() {},

  methods: {
    menuRegist() {
      this.showModal = true;
    },

    CancleBtn() {
      this.showModal = false;
    },

    CloseBtn() {
      this.showModal = false;
    },
  },

  computed: {},
};
</script>
